import { useRouteError } from "react-router";
import { ErrorState } from "@/components/data/error-state";

/** Vite/browsers word a failed lazy-route import differently; all of them mean the chunk is gone after a deploy. */
function isStaleChunkError(error: unknown): boolean {
  const message = error instanceof Error ? error.message : "";
  return (
    message.includes("Failed to fetch dynamically imported module") ||
    message.includes("error loading dynamically imported module") ||
    message.includes("Importing a module script failed")
  );
}

/** Router-level fallback: replaces React Router's default "Unexpected Application Error!" page. */
export function RouteError() {
  const error = useRouteError();
  const stale = isStaleChunkError(error);

  return (
    <div className="flex min-h-svh flex-col bg-background text-foreground">
      <ErrorState
        message={
          stale
            ? "A new version of the app is available. Reload to continue."
            : "Something went wrong loading this page."
        }
        onRetry={() => window.location.reload()}
      />
    </div>
  );
}
